const CLICK_SUBID_KEY = "keitaro_postback_subid";

/** Порядок для Keitaro: sub3 = click id після редіректу, subid, sub2 = мітка кампанії */
const KEITARO_CLICK_PRIORITY = [
  "subid",
  "sub3",
  "sub2",
  "click_id",
  "clickid",
  "_subid",
  "sub_id_3",
  "sub_id_2",
  "sub_id_1",
  "external_id",
  "id",
];

const URL_PERSIST_KEYS = [
  "subid",
  "sub3",
  "sub2",
  "sub1",
  "click_id",
  "clickid",
  "_subid",
  "sub_id_3",
  "sub_id_2",
  "sub_id_1",
  "external_id",
  "id",
  "pid",
  "offer_id",
];

function readLs(key) {
  try {
    return window.localStorage.getItem(key) || "";
  } catch {
    return "";
  }
}

function writeLs(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

function resolveClickSubid(sp) {
  for (const key of KEITARO_CLICK_PRIORITY) {
    const fromUrl = sp.get(key);
    if (fromUrl) {
      return fromUrl;
    }
    const fromLs = readLs(key);
    if (fromLs) {
      return fromLs;
    }
  }
  return readLs(CLICK_SUBID_KEY);
}

/**
 * Зберігає всі query-параметри + click id для постбека.
 * portu.top/m6tNmd?sub2=pwa1 → mineplay.top?sub2=pwa1&sub3={clickid}
 */
export function persistKeitaroClickSubid() {
  if (typeof window === "undefined") return "";

  const sp = new URLSearchParams(window.location.search);

  for (const key of URL_PERSIST_KEYS) {
    const fromUrl = sp.get(key);
    if (fromUrl) {
      writeLs(key, fromUrl);
    }
  }

  const resolved = resolveClickSubid(sp);
  if (resolved) {
    writeLs(CLICK_SUBID_KEY, resolved);
  }

  return resolved;
}

export function getKeitaroClickSubid() {
  if (typeof window === "undefined") return "";
  return persistKeitaroClickSubid();
}
